import React, { lazy } from "react";
// import {RouteProps} from 'react-router-dom';
import {
  mainPages,
  parkingModals,
  passwordModals,
  profileModals,
  reservationModals,
  subscriptionModals,
  subscriptionPaymentModals,
  paymentModals,
  testPages,
} from "../menu";
import { RouteType } from "./routeTypes";

const MAINPAGES = {
  HOME: lazy(() => import("../pages/Home/index")),
  NEEDHELP: lazy(() => import("../pages/Faq/index")),
  SERVICE: lazy(() => import("../pages/Service/index")),
  RECRUTMENT: lazy(() => import("../pages/Careers/index")),
  ABOUT: lazy(() => import("../pages/About/index")),
  EXPERTISE: lazy(() => import("../pages/RoadCompany/index")),
  LEGALMENTIONS: lazy(() => import("../pages/LegalInformation/index")),
  ROI: lazy(() => import("../pages/Roi/index")),
  CITYPAGE: lazy(() => import("../pages/CityPage/index")),
  CITYROSELARD: lazy(() => import("../pages/CityPage/rosalare")),
};

const CARTPAGE = lazy(() => import("../components/cart/CartPage"));
const CARTPAYMENTPAGE = lazy(() => import("../pages/Payment/PaymentCartPage"));
const PASSWORDMODALS = {
  RESETPASSWORD: lazy(() => import("../pages/ForgotPsw/index")),
  PASSWORDUPDATE: lazy(() => import("../pages/PasswordUpdate/index")),
};

const RESERVATIONMODALS = {
  PARTNERARCHIVEDRESERVATIONS: lazy(
    () => import("../views/PartnerProfile/ArchivedReservations"),
  ),
  PARTNERCREATERESERVATIONS: lazy(
    () => import("../views/PartnerProfile/AddBulkReservation"),
  ),
  PARTNERUPDATERESERVATIONS: lazy(
    () => import("../views/PartnerProfile/UpdateBulkReservation"),
  ),
  PARTNERDETAILSRESERVATION: lazy(
    () => import("../views/PartnerProfile/ReservationDetails"),
  ),
  UCLARCHIVEDRESERVATION: lazy(
    () => import("../views/PartnerProfile/UclAccount/UCLArchivedReservations"),
  ),
  PARTNERUPDATERESERVATION: lazy(
    () => import("../views/PartnerProfile/UpdateSingleReservation"),
  ),
};

const PARKINGMODALS = {
  PARKINGSERVICE: lazy(() => import("../pages/Parkings")),
  PARKINGRESERVATION: lazy(() => import("../pages/ReservationStaticPage")),
  PARKINGSUBSCRIPTION: lazy(() => import("../pages/SubAndReservInfo")),
  PARKINGLIST: lazy(() => import("../components/CityParks")),
  PARKINGRESERVATIONSUB: lazy(() => import("../pages/PageStaticOne")),
  RESERVATIONCONFIRMATION: lazy(
    () => import("../pages/Reservation/ConfirmReservation"),
  ),
  LDRESERVATIONCONFIRMATION: lazy(
    () => import("../pages/Reservation/ConfirmLDReservation"),
  ),
};

const SUBSCRIPTIONMODALS = {
  SUBSCRIPTION: lazy(() => import("../pages/SubscriptionInfoPage/index")),
  SUBSCRIPTIONCONFIRMATION: lazy(() => import("../pages/Subscription/index")),
  PARTNERARCHIVEDSUBSCRIPTIONS: lazy(
    () => import("../views/PartnerProfile/Subscription/ArchivedSubscriptions"),
  ),
  PARTNERCREATESUBSCRIPTIONS: lazy(
    () => import("../views/PartnerProfile/Subscription/AddBulkSubscription"),
  ),
  PARTNERUPDATESUBSCRIPTION: lazy(
    () =>
      import("../views/PartnerProfile/Subscription/UpdateSingleSubscription"),
  ),
  UCLARCHIVEDSUBSCRIPTIONS: lazy(
    () =>
      import(
        "../views/PartnerProfile/UclAccount/Subscription/UCLArchivedSubscriptions"
      ),
  ),
  PARTNERUPDATESUBSCRIPTIONS: lazy(
    () =>
      import("../views/PartnerProfile/Subscription/BulkUpdateSubscriptions"),
  ),
  PARTNERSUBSCRIPTIONDETAILS: lazy(
    () => import("../views/PartnerProfile/Subscription/SubscriptionDetails"),
  ),
};

const SUBSCRIPTIONPAYMENTMODALS = {
  SUBSCRIPTIONPAYMENT: lazy(
    () => import("../views/SubAndReservConfirmation/Subscription/payementSub"),
  ),
  PAYMENTREDIRECTION: lazy(() => import("../pages/paymentRedirect")),
  DOMICILIATION: lazy(() => import("../views/Payment/RedirectionStatus")),
};

const PAYMENTMODALS = {
  REDIRECTIONSTATUS: lazy(() => import("../views/Payment/RedirectionStatus")),
};

const PROFILEMODALS = {
  PROFILE: lazy(() => import("../pages/Profile/index")),
  EDITPROFILE: lazy(() => import("../views/Profile/EditeProfile/EditProfile")),
  VERIFYPROFILE: lazy(() => import("../pages/Verification/index")),
};

const TEST = {
  LOADING: lazy(() => import("../pages/Loading")),
};

const presentation: RouteType[] = [
  {
    title: "Mon panier",
    path: "/panier",
    element: <CARTPAGE />,
    auth: true,
  },
  {
    title: "Paiement du panier",
    path: "/panier/paiement",
    element: <CARTPAYMENTPAGE />,
    auth: true,
  },
  {
    title: mainPages.home.title,
    path: mainPages.home.path,
    element: <MAINPAGES.HOME />,
    auth: mainPages.home.auth,
  },
  {
    title: mainPages.needHelp.title,
    path: mainPages.needHelp.path,
    element: <MAINPAGES.NEEDHELP />,
    auth: mainPages.needHelp.auth,
  },
  {
    title: mainPages.service.title,
    path: mainPages.service.path,
    element: <MAINPAGES.SERVICE />,
    auth: mainPages.service.auth,
  },
  {
    title: mainPages.recrutment.title,
    path: mainPages.recrutment.path,
    element: <MAINPAGES.RECRUTMENT />,
    auth: mainPages.recrutment.auth,
  },
  {
    title: mainPages.about.title,
    path: mainPages.about.path,
    element: <MAINPAGES.ABOUT />,
    auth: mainPages.about.auth,
  },
  {
    title: mainPages.expertise.title,
    path: mainPages.expertise.path,
    element: <MAINPAGES.EXPERTISE />,
    auth: mainPages.expertise.auth,
  },
  {
    title: mainPages.legalMentions.title,
    path: mainPages.legalMentions.path,
    element: <MAINPAGES.LEGALMENTIONS />,
    auth: mainPages.legalMentions.auth,
  },
  {
    title: mainPages.roi.title,
    path: mainPages.roi.path,
    element: <MAINPAGES.ROI />,
    auth: mainPages.roi.auth,
  },
  {
    title: mainPages.cityPage.title,
    path: mainPages.cityPage.path,
    element: <MAINPAGES.CITYPAGE />,
    auth: mainPages.cityPage.auth,
  },
  {
    title: mainPages.cityPageNL.title,
    path: mainPages.cityPageNL.path,
    element: <MAINPAGES.CITYPAGE />,
    auth: mainPages.cityPageNL.auth,
  },
  {
    title: passwordModals.resetPassword.title,
    path: passwordModals.resetPassword.path,
    element: <PASSWORDMODALS.RESETPASSWORD />,
    auth: passwordModals.resetPassword.auth,
  },
  {
    title: passwordModals.passwordUpdate.title,
    path: passwordModals.passwordUpdate.path,
    element: <PASSWORDMODALS.PASSWORDUPDATE />,
    auth: passwordModals.passwordUpdate.auth,
  },

  {
    title: reservationModals.partnerCreateReservations.title,
    path: reservationModals.partnerCreateReservations.path,
    element: <RESERVATIONMODALS.PARTNERCREATERESERVATIONS />,
    auth: reservationModals.partnerCreateReservations.auth,
  },
  {
    title: reservationModals.partnerUpdateReservations.title,
    path: reservationModals.partnerUpdateReservations.path,
    element: <RESERVATIONMODALS.PARTNERUPDATERESERVATIONS />,
    auth: reservationModals.partnerUpdateReservations.auth,
  },
  {
    title: reservationModals.partnerDetailsReservation.title,
    path: reservationModals.partnerDetailsReservation.path,
    element: <RESERVATIONMODALS.PARTNERDETAILSRESERVATION />,
    auth: reservationModals.partnerDetailsReservation.auth,
  },
  {
    title: reservationModals.partnerArchivedReservations.title,
    path: reservationModals.partnerArchivedReservations.path,
    element: <RESERVATIONMODALS.PARTNERARCHIVEDRESERVATIONS />,
    auth: reservationModals.partnerArchivedReservations.auth,
  },
  {
    title: reservationModals.uclArchivedReservations.title,
    path: reservationModals.uclArchivedReservations.path,
    element: <RESERVATIONMODALS.UCLARCHIVEDRESERVATION />,
    auth: reservationModals.uclArchivedReservations.auth,
  },
  {
    title: parkingModals.parkingService.title,
    path: parkingModals.parkingService.path,
    element: <PARKINGMODALS.PARKINGSERVICE />,
    auth: parkingModals.parkingService.auth,
  },
  {
    title: parkingModals.parkingReservation.title,
    path: parkingModals.parkingReservation.path,
    element: <PARKINGMODALS.PARKINGRESERVATION />,
    auth: parkingModals.parkingReservation.auth,
  },
  {
    title: parkingModals.parkingSubscription.title,
    path: parkingModals.parkingSubscription.path,
    element: <PARKINGMODALS.PARKINGSUBSCRIPTION />,
    auth: parkingModals.parkingSubscription.auth,
    noAccess: parkingModals.parkingSubscription.noAccess,
  },
  {
    title: parkingModals.parkingSubscriptionNL.title,
    path: parkingModals.parkingSubscriptionNL.path,
    element: <PARKINGMODALS.PARKINGSUBSCRIPTION />,
    auth: parkingModals.parkingSubscriptionNL.auth,
    noAccess: parkingModals.parkingSubscriptionNL.noAccess,
  },
  {
    title: parkingModals.parkingList.title,
    path: parkingModals.parkingList.path,
    element: <PARKINGMODALS.PARKINGLIST />,
    auth: parkingModals.parkingList.auth,
  },
  {
    title: parkingModals.parkingListNL.title,
    path: parkingModals.parkingListNL.path,
    element: <PARKINGMODALS.PARKINGLIST />,
    auth: parkingModals.parkingListNL.auth,
  },
  {
    title: parkingModals.parkingReservationSub.title,
    path: parkingModals.parkingReservationSub.path,
    element: <PARKINGMODALS.PARKINGRESERVATIONSUB />,
    auth: parkingModals.parkingReservationSub.auth,
  },
  {
    title: parkingModals.reservationConfirmation.title,
    path: parkingModals.reservationConfirmation.path,
    element: <PARKINGMODALS.RESERVATIONCONFIRMATION />,
    auth: parkingModals.reservationConfirmation.auth,
    noAccess: parkingModals.reservationConfirmation.noAccess,
  },
  {
    title: parkingModals.ldReservationConfirmation.title,
    path: parkingModals.ldReservationConfirmation.path,
    element: <PARKINGMODALS.LDRESERVATIONCONFIRMATION />,
    auth: parkingModals.ldReservationConfirmation.auth,
    noAccess: parkingModals.ldReservationConfirmation.noAcess,
  },

  {
    title: subscriptionModals.subscription.title,
    path: subscriptionModals.subscription.path,
    element: <SUBSCRIPTIONMODALS.SUBSCRIPTION />,
    auth: subscriptionModals.subscription.auth,
  },
  {
    title: subscriptionModals.subscriptionConfirmation.title,
    path: subscriptionModals.subscriptionConfirmation.path,
    element: <SUBSCRIPTIONMODALS.SUBSCRIPTIONCONFIRMATION />,
    auth: subscriptionModals.subscriptionConfirmation.auth,
    noAccess: subscriptionModals.subscriptionConfirmation.noAccess,
  },

  {
    title: subscriptionModals.partnerCreateSubscription.title,
    path: subscriptionModals.partnerCreateSubscription.path,
    element: <SUBSCRIPTIONMODALS.PARTNERCREATESUBSCRIPTIONS />,
    auth: subscriptionModals.partnerCreateSubscription.auth,
  },
  {
    title: subscriptionModals.partnerUpdateSubscription.title,
    path: subscriptionModals.partnerUpdateSubscription.path,
    element: <SUBSCRIPTIONMODALS.PARTNERUPDATESUBSCRIPTION />,
    auth: subscriptionModals.partnerUpdateSubscription.auth,
  },
  {
    title: subscriptionModals.partnerArchivedSubscriptions.title,
    path: subscriptionModals.partnerArchivedSubscriptions.path,
    element: <SUBSCRIPTIONMODALS.PARTNERARCHIVEDSUBSCRIPTIONS />,
    auth: subscriptionModals.partnerArchivedSubscriptions.auth,
  },
  {
    title: subscriptionModals.uclArchivedSubscriptions.title,
    path: subscriptionModals.uclArchivedSubscriptions.path,
    element: <SUBSCRIPTIONMODALS.UCLARCHIVEDSUBSCRIPTIONS />,
    auth: subscriptionModals.uclArchivedSubscriptions.auth,
  },
  {
    title: subscriptionPaymentModals.subscriptionPayment.title,
    path: subscriptionPaymentModals.subscriptionPayment.path,
    element: <SUBSCRIPTIONPAYMENTMODALS.SUBSCRIPTIONPAYMENT />,
    auth: subscriptionPaymentModals.subscriptionPayment.auth,
    noAccess: subscriptionPaymentModals.subscriptionPayment.noAccess,
  },
  {
    title: subscriptionPaymentModals.paymentRedirection.title,
    path: subscriptionPaymentModals.paymentRedirection.path,
    element: <SUBSCRIPTIONPAYMENTMODALS.PAYMENTREDIRECTION />,
    auth: subscriptionPaymentModals.paymentRedirection.auth,
  },
  {
    title: paymentModals.paymentRedirection.title,
    path: paymentModals.paymentRedirection.path,
    element: <PAYMENTMODALS.REDIRECTIONSTATUS />,
    auth: paymentModals.paymentRedirection.auth,
  },
  {
    title: profileModals.profile.title,
    path: profileModals.profile.path,
    element: <PROFILEMODALS.PROFILE />,
    auth: profileModals.profile.auth,
  },
  {
    title: profileModals.editProfile.title,
    path: profileModals.editProfile.path,
    element: <PROFILEMODALS.EDITPROFILE />,
    auth: profileModals.editProfile.auth,
  },
  {
    title: profileModals.verifyProfile.title,
    path: profileModals.verifyProfile.path,
    element: <PROFILEMODALS.VERIFYPROFILE />,
    auth: profileModals.verifyProfile.auth,
  },

  {
    title: testPages.loading.title,
    path: testPages.loading.path,
    element: <TEST.LOADING />,
    auth: testPages.loading.auth,
  },

  {
    title: reservationModals.partnerUpdateReservation.title,
    path: reservationModals.partnerUpdateReservation.path,
    element: <RESERVATIONMODALS.PARTNERUPDATERESERVATION />,
    auth: reservationModals.partnerUpdateReservation.auth,
  },
  {
    title: subscriptionModals.partnerUpdateSubscriptions.title,
    path: subscriptionModals.partnerUpdateSubscriptions.path,
    element: <SUBSCRIPTIONMODALS.PARTNERUPDATESUBSCRIPTIONS />,
    auth: subscriptionModals.partnerUpdateSubscriptions.auth,
  },
  {
    title: subscriptionModals.partnerSubscriptionDetails.title,
    path: subscriptionModals.partnerSubscriptionDetails.path,
    element: <SUBSCRIPTIONMODALS.PARTNERSUBSCRIPTIONDETAILS />,
    auth: subscriptionModals.partnerSubscriptionDetails.auth,
  },
];

export const contents = [...presentation];
